var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-wrapper"},[_c('i',{staticClass:"fas fa-search"}),_c('input',{attrs:{"type":"text","placeholder":"Pesquisar município..."},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }